var React = require('react');
var MatomoContext = require('./MatomoContext');

var MatomoProvider = function MatomoProvider(props) {
  var children = props.children,
      value = props.value;

  var Context = MatomoContext;
  return React.createElement(Context.Provider, { value: value }, children);
};

module.exports = MatomoProvider;

//# sourceMappingURL=MatomoProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datapunt/matomo-tracker-react/es/MatomoProvider.js
// module id = 766
// module chunks = 0